import type DebugSettings from './DebugSettings';

export default function writeDebugSettingsField<T extends keyof DebugSettings>(
  settingsFieldKey: T,
  value: DebugSettings[T],
) {
  localStorage.setItem(`debugSettings.${settingsFieldKey}`, JSON.stringify(value));
}
